module.exports = __webpack_public_path__ + "InterstateWGL-Regular.77311b381257ef45d60b.woff";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/InterstateWGL-Regular.woff
// module id = ../../../../../src/assets/layout/fonts/InterstateWGL-Regular.woff
// module chunks = styles